import { Map, List, Seq } from "immutable";
import { STATE_STATUS } from "constants/state-status";
export function createListReducer(actions, Record = null) {

    const INITIAL_STATE = Map({
        data: Map({}),
        pages: Map({
            1: List([])
        }),
        pagination: Map({
            page: 1,
            pageSize: 20,
            totalCount: null
        }),
        params: Map({}),
        filters: Map({}),
        error: null,
        loading: false,
        createUpdate: new Map({
            status: null,
            data: null
        })
        
    });

    return (state = INITIAL_STATE, { type, payload, error }) => {
        switch (type) {
        case actions.FETCH:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["pagination", "page"], payload.params && payload.params.page)
                    .setIn(["pagination", "pageSize"], payload.params && payload.params.page_size)
                    .mergeIn(["params"], payload.params)
                    .mergeIn(["filters"], payload.filters)
                    .set("loading", true)
                    .setIn(["createUpdate", "status"], null);
            });
        case actions.FETCHED:
            return state.withMutations(mutator => {
                return mutator
                    .mergeIn(["data"], Seq(List(payload.data.results)).map(_ => Record ? new Record(_) : _).toMap())
                    .setIn(["pages", payload.params && payload.params.params.page], List(payload.data.results.map(_ => _.id)))
                    .setIn(["pagination", "totalCount"], payload.data && payload.data.count)
                    .set("loading", false);
            });
        case actions.FETCH_FAILED:
            return state.withMutations(mutator => {
                return mutator
                    .set("error", error)
                    .set("loading", false);
            });
        case actions.CREATE:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.CREATING);
            });
        case actions.CREATED:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.CREATED);
            });
        case actions.FAILED_CREATE:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.CREATE_FAILED);
            });
        case actions.UPDATE:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.UPDATING);
            });
        case actions.UPDATED:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.UPDATED);
            });
        case actions.FAILED_UPDATE:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["createUpdate", "status"], STATE_STATUS.UPDATE_FAILED);
            });
        case "LOGOUT":
            return INITIAL_STATE;
        default:
            return state;
        }
    };
}